import styled, { css } from "styled-components";

import { Button, Input } from "components/ui";
import { SelectWrapper } from "components/ui/dropdown/Dropdown.styled";
import Dropdown from "components/ui/dropdown";

import { media } from "constants/media";

export const DistanceCalculatorWrapper = styled.form`
    background: linear-gradient(91.73deg, #f39000 1.99%, #fbbc12 56.66%);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    position: relative;

    ${media.mdUp} {
        &::before {
            background: linear-gradient(204.88deg, #f39000, #fbbc12);
            border-radius: 16px;
            content: "";
            inset: -1px;
            position: absolute;
            z-index: -1;
        }
    }

    ${media.lgUp} {
        flex-direction: row;
    }
`;

export const InputsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.mdUp} {
        flex-direction: row;

        > div {
            width: 50%;
        }
    }

    ${media.lgUp} {
        gap: 16px;

        > div {
            width: unset;
        }
    }
`;

export const StyledInput = styled(Input)`
    ${media.mdUp} {
        width: 50%;
    }

    ${media.lgUp} {
        width: 320px;
    }
`;

export const StyledButton = styled(Button)<{ type: string; loading: boolean }>`
    display: none;

    ${media.mdUp} {
        border-radius: 32px;
        display: inline-flex;
        height: 56px;
        position: relative;
        width: 100%;
    }

    ${media.lgUp} {
        align-self: flex-end;
        width: 100%;
    }
`;

export const LoaderWrapper = styled.div<{ loading: boolean }>`
    display: none;

    ${media.mdUp} {
        align-items: center;
        display: flex;
        position: relative;
        width: 100%;

        //stylelint-disable
        ${({ loading }) =>
            loading &&
            css`
                cursor: not-allowed;

                > button {
                    opacity: 0.5;
                }
            `}
        //stylelint-enable


        > div {
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translateX(-50%);
        }
    }
`;

export const StyledDropdown = styled(Dropdown)`
    ${media.lgUp} {
        ${SelectWrapper} {
            width: fit-content;
        }

        select {
            width: 160px;
        }
    }
`;
